import * as Doka from './doka.mjs';

export default class DokaFactory {
    static create(vue) {
        const config = DokaFactory.buildLabels(vue);
        config.utils = ['crop'];
        return Doka.create(config);
    }

    static buildLabels(vue) {
        return {
            labelButtonReset: vue.$t('doka label labelButtonReset'),
            labelButtonCancel: vue.$t('doka label labelButtonCancel'),
            labelButtonConfirm: vue.$t('doka label labelButtonConfirm'),
            labelStatusAwaitingImage: vue.$t('doka label labelStatusAwaitingImage'),
            labelStatusLoadingImage: vue.$t('doka label labelStatusLoadingImage'),
            labelStatusLoadImageError: vue.$t('doka label labelStatusLoadImageError'),
            labelStatusProcessingImage: vue.$t('doka label labelStatusProcessingImage'),
            labelColorBrightness: vue.$t('doka label labelColorBrightness'),
            labelColorContrast: vue.$t('doka label labelColorContrast'),
            labelColorExposure: vue.$t('doka label labelColorExposure'),
            labelColorSaturation: vue.$t('doka label labelColorSaturation'),
            labelResizeWidth: vue.$t('doka label labelResizeWidth'),
            labelResizeHeight: vue.$t('doka label labelResizeHeight'),
            labelResizeApplyChanges: vue.$t('doka label labelResizeApplyChanges'),
            labelCropInstructionZoom: vue.$t('doka label labelCropInstructionZoom'),
            labelButtonCropZoom: vue.$t('doka label labelButtonCropZoom'),
            labelButtonCropRotateLeft: vue.$t('doka label labelButtonCropRotateLeft'),
            labelButtonCropRotateRight: vue.$t('doka label labelButtonCropRotateRight'),
            labelButtonCropRotateCenter: vue.$t('doka label labelButtonCropRotateCenter'),
            labelButtonCropFlipHorizontal: vue.$t('doka label labelButtonCropFlipHorizontal'),
            labelButtonCropFlipVertical: vue.$t('doka label labelButtonCropFlipVertical'),
            labelButtonCropAspectRatio: vue.$t('doka label labelButtonCropAspectRatio'),
            labelButtonCropToggleLimit: vue.$t('doka label labelButtonCropToggleLimit'),
            labelButtonCropToggleLimitEnable: vue.$t('doka label labelButtonCropToggleLimitEnable'),
            labelButtonCropToggleLimitDisable: vue.$t('doka label labelButtonCropToggleLimitDisable'),
            labelButtonUtilCrop: vue.$t('doka label labelButtonUtilCrop'),
            labelButtonUtilFilter: vue.$t('doka label labelButtonUtilFilter'),
            labelButtonUtilColor: vue.$t('doka label labelButtonUtilColor'),
            labelButtonUtilResize: vue.$t('doka label labelButtonUtilResize'),
            labelButtonUtilMarkup: vue.$t('doka label labelButtonUtilMarkup'),
            labelMarkupTypeRectangle: vue.$t('doka label labelMarkupTypeRectangle'),
            labelMarkupTypeEllipse: vue.$t('doka label labelMarkupTypeEllipse'),
            labelMarkupTypeText: vue.$t('doka label labelMarkupTypeText'),
            labelMarkupTypeLine: vue.$t('doka label labelMarkupTypeLine'),
            labelMarkupSelectFontSize: vue.$t('doka label labelMarkupSelectFontSize'),
            labelMarkupSelectFontFamily: vue.$t('doka label labelMarkupSelectFontFamily'),
            labelMarkupSelectLineDecoration: vue.$t('doka label labelMarkupSelectLineDecoration'),
            labelMarkupSelectLineStyle: vue.$t('doka label labelMarkupSelectLineStyle'),
            labelMarkupSelectShapeStyle: vue.$t('doka label labelMarkupSelectShapeStyle'),
            labelMarkupRemoveShape: vue.$t('doka label labelMarkupRemoveShape'),
            labelMarkupToolSelect: vue.$t('doka label labelMarkupToolSelect'),
            labelMarkupToolDraw: vue.$t('doka label labelMarkupToolDraw'),
            labelMarkupToolLine: vue.$t('doka label labelMarkupToolLine'),
            labelMarkupToolText: vue.$t('doka label labelMarkupToolText'),
            labelMarkupToolRect: vue.$t('doka label labelMarkupToolRect'),
            labelMarkupToolEllipse: vue.$t('doka label labelMarkupToolEllipse'),
        }
    }
}
